import React from 'react';
import Tag from './Tag';
import Dimensions from 'react-dimensions';
import PropTypes from 'prop-types';
import $ from 'jquery';
import * as bookTagsListService from '../../../services/domain/bookTagsListService';

export class TagsList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = { tagsWidths: [] };
  }

  static propTypes = {
    tags: PropTypes.array
  };

  static getTagsWidthsAux(tagsWidths) {
    let customTags = $('.custom-tag');
    let tagsWidthsAux = [];

    for (let i = 0; i < customTags.length; i++) {
      let customTag = $(`#custom-tag-${i}`);

      let tagWidth = customTag.width() + 24 + 24 + 2; // margin-left: 24px; padding: 0 12px 0 12px; border: 1px;
      tagsWidthsAux.push(tagWidth);
    }

    return tagsWidthsAux;
  }

  setInStateTagsWidths() {
    const { tagsWidths } = this.state;
    const { tags } = this.props;

    if (tags && tags.length !== tagsWidths.length) {
      this.setState({ tagsWidths: TagsList.getTagsWidthsAux(tagsWidths) });
    }
  }

  getMaxTags() {
    const { tagsWidths } = this.state;
    const { tags, containerWidth } = this.props;
    let maxTags = tags && tags.length ? tags.length : 0;

    if (tags && tagsWidths.length === tags.length)
      maxTags = bookTagsListService.calculateTagsNumber(tagsWidths, containerWidth);

    return maxTags;
  }

  componentDidMount() {
    this.setInStateTagsWidths();
  }

  componentDidUpdate() {
    this.setInStateTagsWidths();
  }

  renderTags() {
    const { tags } = this.props;
    let maxTags = this.getMaxTags();
    let tagsList = [];

    if (tags) {
      for (let i = 0; i < tags.length; i++) {
        if (i >= maxTags) {
          tagsList.push(<Tag ellipsis={true} key={i} name={tags[i]} id={i} />);
          break;
        }

        tagsList.push(<Tag ellipsis={false} key={i} name={tags[i]} id={i} />);
      }
    }

    return tagsList;
  }

  render() {
    return <div className="tags-container">{this.renderTags()}</div>;
  }
}

export default Dimensions({ containerStyle: { paddingTop: '24px' } })(TagsList);
